<template>
    <div>
        <prescriptionWindow :textP="presText" v-if="showPres" @CloseBox="showPres=false"></prescriptionWindow>
        <sendDocMessage v-if="messagingOrderModel" @CloseBox="messagingOrderModel=false" @submitMessage="submitMessage"></sendDocMessage>
        <showImageBox v-if="ImageBox" @CloseBox="ImageBox=false" :id="imageUploadId" @showSuccessUpload="showSuccessUpload" @submitMessage="submitMessage"></showImageBox>
        <tostWindow :message="toastMessage" v-if="showT" />
        <div class="portal-tab-div" v-if="!isLoading">
            <div class="tab-headers-div">
                <div class="text-block-929">Order Tracking &amp; Status Updates</div>
                <div class="text-block-1045">Use this page to check the status of all your prescriptions &amp; supplements</div>
            </div>
            <progressItems :progressItems="progressItems" @showModel="showModel" @showModelMessage="showModelMessage" @showImageUpload="showImageUpload" v-if="progressItems.length"></progressItems>
            <div v-else>
                <p class="text-block-1045">You don't have any orders yet. <a href="/weight-loss-plan">Click here to get started.</a></p>
            </div>
        </div>
        <div style="height:280px"></div>
    </div>
    </template>
    
    <script>
    import {
        getProductById,
        getProductsByCategory
    } from '@/utils/productData'
    import progressItems from './progressItems.vue';
    import prescriptionWindow from './prescriptionWindow.vue';
    import sendDocMessage from './sendDocMessage.vue';
    import showImageBox from './showImageBox.vue';
    import tostWindow from './tostWindow.vue'
    
    export default {
        name: 'myNewSelf',
        props: {
            baseUrl: {
                type: String,
                required: true
            },
            user: {
                type: Object,
                required: true
            },
        },
        components:{
            progressItems,
            prescriptionWindow,
            sendDocMessage,
            showImageBox,
            tostWindow
        },
        data() {
            return {
                isLoading: true,
                showPres: false,
                messagingOrderModel: false,
                ImageBox: false,
                imageUploadId: '',
                messagingOrderID: '',
                showT:false,
                presText: '',
                toastMessage: '',
                progressItems: [],
                openDropdown: null,
                categories: ['MIND', 'BODY', 'WEIGHT', 'SEX', 'LONGEVITY', 'SKIN', 'HAIR'],
                statusOrder: {
                    pending_approval: 0,
                    appointment_required: 1,
                    accepted: 2,
                    prescription_received: 3,
                    delivered: 4
                },
                steps: [{
                        title: 'Onboarding Questionnaire',
                        description: 'Click Here To Submit.',
                        isLink: true,
                        link_type: 'assesment'
                    },
                    {
                        title: 'Schedule Appointment',
                        description: 'Click Here to Schedule.',
                        isLink: true,
                        link_type: 'appointment'
                    },
                    {
                        title: 'Prescription Received',
                        description: 'This is some text inside of a div block.'
                    },
                    {
                        title: 'Schedule Monthly Follow Up Visit',
                        description: 'This needs to be completed in order to receive your next dosage',
                        dueDate: '12/12/24'
                    }
                ]
            }
        },
        computed: {
            recommendedItems() {
                let items = getProductsByCategory('Sex', 1);
    
                return items;
            }
        },
        methods: {
            async submitMessage(message){
                const response = await this.$axios.post(`${this.baseUrl}/api/send-doc-message`,{
                    message: message,
                    visitId: this.messagingOrderID
                });
                if(response.data.status=="success"){
                    this.messagingOrderModel = false;
                    this.messagingOrderID='';
                    alert("Message sent");
                }
            },
            showSuccessUpload(){
                this.toastMessage = "Image uploaded";
                this.showT = true;
                this.ImageBox = false;
            },
            showImageUpload(id){
                this.imageUploadId=id;
                this.ImageBox=true;
            },
            showModel(presText){
                this.presText= presText;
                this.showPres= true;
            },
            showModelMessage(id){
                this.messagingOrderID= id;
                this.messagingOrderModel= true;
            },
            getCurrentStepIndex(status) {
                return this.statusOrder[status];
            },
            getFullProductName(id) {
                let product = getProductById(id);
                return product[0].name;
            },
            getFullProductImage(id) {
                let product = getProductById(id);
                return product[0].image_pre_text;
            },
            toProperCase(text) {
                return text.toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            },
            toggleDropdown(index) {
                this.openDropdown = this.openDropdown === index ? null : index;
            },
            async checkProgressAvailability() {
            try {
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/order-items`);
                    if (response.data.status === 'success') {
                        if(response.data.orders.length){
                            await this.$store.dispatch('updateProgress', {
                                items: response.data.orders,
                                timestamp: Date.now().toString()
                            });
                            this.progressItems = response.data.orders.sort((a, b) => {
                                return new Date(b.created_at) - new Date(a.created_at);
                            });
                            if(response.data.health_id){
                            await this.$store.dispatch('updateHealth', {
                                    health_id: response.data.health_id
                                }); 
                            }
                            //get latest order and set prescription 
                            // Get the latest prescription data from the first (most recent) order
                            const latestPrescription = this.progressItems[0]?.prescription_data || [];
                            this.$store.dispatch('setPrescription', latestPrescription)
                            this.$store.dispatch('setCaseID', {id: this.progressItems[0].external_visit_id , provider: this.progressItems[0].provider})
                            this.isLoading = false;
                            const latestValidOrder = this.progressItems.find(order => order.status !== 'pending_approval');

                            if (latestValidOrder) {
                                this.$store.dispatch('setEncounterId', {encounter_id : latestValidOrder.external_visit_id, provider: latestValidOrder.provider});
                            } else {
                                console.warn('No valid order found (excluding pending_approval status)');
                            }
                            this.isLoading= false;
                        }else{
                            this.isLoading= false;
                        }
                        
                    }
                
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            }
        },
            getVisibleSteps(status) {
                const currentIndex = this.statusOrder[status];
                return this.steps.slice(0, currentIndex + 1);
            },
            getStepIcon(stepIndex, itemStatus) {
                const currentStatusIndex = this.statusOrder[itemStatus];
    
                if (stepIndex < currentStatusIndex) return 'Check-black';
                if (stepIndex === currentStatusIndex) return 'Urgent';
                return 'open';
            }
        },
        mounted() {
            this.checkProgressAvailability();
        }
    }
    </script>
    